import React, { useContext } from 'react';
import { HeaderDynamicContext } from '../../../../contexts/HeaderDynamicData/HeaderDynamicData';
import Bag from './Bag';

function BagVM() {
  const { data } = useContext(HeaderDynamicContext);
  const bagPeek = {
    bagCount: Number(data.items || 0),
    subTotal: data.subTotal,
    lineItems: data.lineItems,
  };
  return <Bag bagPeekData={bagPeek} />;
}

export default BagVM;
